// extracted by mini-css-extract-plugin
export default {"root":"_4K4DE","stat":"_3_C8i","label":"_3rBRP"};